
$(document).ready(function(){

//   alert($("input[name=option1]:checked").val());
  
 // add or remove ipad based on loaded variant  
 if($("input[name=option1]:checked").val() == 'Digital') {
  	$('.product-single__media-wrapper,.product-single__quantity, .product-single__add-to-cart').addClass('digital');
  } else {
  $('.product-single__media-wrapper,.product-single__quantity, .product-single__add-to-cart').removeClass('digital');
  }
  
// add or remove ipad based on selected variant  

$('input[name=option1]').change(function() { 
  if(this.value == 'Digital') {
  	$('.product-single__media-wrapper,.product-single__quantity, .product-single__add-to-cart').addClass('digital');        
  } else {
  $('.product-single__media-wrapper,.product-single__quantity, .product-single__add-to-cart').removeClass('digital');
  }
});
  
  if ($(window).width() > 591) {
   		$('.filter-toggle').click();
	};
});

const selectVariantByClickingImage = {

  // Create variant images from productJson object
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (
        typeof variant.featured_image !== 'undefined' &&
        variant.featured_image !== null
      ) {
        const variantImage = variant.featured_image.src
          .split('?')[0]
          .replace(/http(s)?:/, '');
        variantImageObject[variantImage] =
          variantImageObject[variantImage] || {};
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (
            typeof variantImageObject[variantImage][optionKey] === 'undefined'
          ) {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
    return variantImageObject;
  },
  _updateVariant: function (event, id, product, variantImages) {
    const arrImage = event.target.src
      .split('?')[0]
      .replace(/http(s)?:/, '')
      .split('.');
    const strExtention = arrImage.pop();
    const strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/, '');
    const strNewImage = `${arrImage.join('.')}.${strRemaining}.${strExtention}`;
    if (typeof variantImages[strNewImage] !== 'undefined') {
      product.variants.forEach((option, index) => {
        const optionValue = variantImages[strNewImage][`option-${index}`];
        if (optionValue !== null && optionValue !== undefined) {
          const selects = document.querySelectorAll('#'+ id + ' [class*=single-option-selector]');
          const options = selects[index].options;
          for (let option, n = 0; (option = options[n]); n += 1) {
            if (option.value === optionValue) {
              selects[index].selectedIndex = n;
              selects[index].dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    }
  },
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-');
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        const thumbnails = document.querySelectorAll('#'+ sectionId + ' img[src*="/products/"]');
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);
          // need to check variants > 1
          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              thumbnail.addEventListener('click', (e) =>
                this._updateVariant(e, sectionId, productObject, variantImages),
              );
            });
          }
        }
      });
    }
  },
};
if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    selectVariantByClickingImage._selectVariant(),
  );
};
    
$('.filter-toggle').on('click',function(){
  var target = $(this).data("target");
  $(target).toggleClass('hide');
  $(this).find('.bi').toggleClass('bi-chevron-down');
  $(this).find('.bi').toggleClass('bi-chevron-left');
});
  
$(function () {
  $(document).scroll(function () {
    var $nav = $("#shopify-section-header");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height()/2);
      $('#logo, .nav-item a').toggleClass('scrolled', $(this).scrollTop() > $nav.height()/2);

  });
});

function setMinHeight(selector){
    $(selector).css("min-height","0px");
    if(window.matchMedia("(min-width: 590px)").matches){
        var heights = $(selector).map(function(){
            return $(this).height() + 20;
        }).get();
        maxHeight = Math.max.apply(null, heights);
        $(selector).css("min-height",maxHeight);
    }
};
function setMinHeightMobile(selector){
    $(selector).css("min-height","0px");
    var heights = $(selector).map(function(){
        return $(this).height() + 20;
    }).get();
    maxHeight = Math.max.apply(null, heights);
    $(selector).css("min-height",maxHeight);
};

// make external links open in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}